<div class="modal-content">
  <div class="modal-header">
    <h1 class="modal-title pull-left" aria-hidden="true">
      {{ "HEALTH_PLAN_POPUP_INFO_LINE5" | globalTranslate }}
    </h1>
    <button
      type="button"
      class="btn-close pull-right"
      [attr.aria-label]="'CLOSE' | globalTranslate"
      (click)="onCancel()"
    >
      <img
        src="../../assets/images/⚛️ icons-close-circle-outline.svg"
        aria-hidden="true"
        alt="close-icon"
        role="presentation"
      />
    </button>
  </div>
  <div class="modal-body">
    <h2 class="page-header sr-only" role="heading" aria-level="1">
      {{ "HEALTH_PLAN_POPUP_INFO_LINE5" | globalTranslate }}
    </h2>
    <p class="pb-2 pt-2">
      {{ "HEALTH_PLAN_POPUP_INFO_LINE1_PART1" | globalTranslate }}
      {{ healthPlanDetails.requestSubmittedDate }}!
    </p>
    <p class="plan_info">
      {{ "HEALTH_PLAN_POPUP_INFO_LINE2_PART1" | globalTranslate }}
      {{ healthPlanDetails.currentHealthPlan }}
      {{ "HEALTH_PLAN_POPUP_INFO_LINE2_PART2" | globalTranslate }}
      {{ healthPlanDetails.futureHealthPlan }}
      {{ "HEALTH_PLAN_POPUP_INFO_LINE2_PART3" | globalTranslate }} <br />{{
        "HEALTH_PLAN_POPUP_INFO_LINE3" | globalTranslate
      }}
    </p>
    @if (isMobileView) {
    <p
      [innerHTML]="'HEALTH_PLAN_POPUP_INFO_LINE4_mobile' | globalTranslate"
      class="pb-3 pt-3"
    ></p>
    } @if (!isMobileView) {
    <p
      [innerHTML]="'HEALTH_PLAN_POPUP_INFO_LINE4' | globalTranslate"
      class="pb-3 pt-3"
    ></p>
    }
  </div>
</div>